export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  ADD_REQUEST: "USERS_ADD_REQUEST",
  ADD_SUCCESS: "USERS_ADD_SUCCESS",
  ADD_FAILURE: "USERS_ADD_FAILURE",

  UPDATE_REQUEST: "USER_UPDATE_REQUEST",
  UPDATE_SUCCESS: "USER_UPDATE_SUCCESS",
  UPDATE_FAILURE: "USER_UPDATE_FAILURE",

  GET_SINGLE_REQUEST: "USER_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "USER_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "USER_GET_SINGLE_FAILURE",

  GET_USER_DETAILS_REQUEST: "USER_GET_DETAILS_REQUEST",
  GET_USER_DETAILS_SUCCESS: "USER_GET_DETAILS_SUCCESS",
  GET_USER_DETAILS_FAILURE: "USER_GET_DETAILS_FAILURE",
  
};
